import { render, staticRenderFns } from "./localChainMoreEnterprise.vue?vue&type=template&id=e5dbbfa2&"
import script from "./localChainMoreEnterprise.vue?vue&type=script&lang=js&"
export * from "./localChainMoreEnterprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports